// test1226
(1226 && 0);
